import React from "react";
import { Formik } from "formik";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import { Modal } from "components/bootstrap";
import { useNewInvestigation } from "security-app/hooks/useInvestigationsAPI";
import FormFields from "./FormFields";
import FormButtons from "./FormButtons";
const INIT_INVESTIGATION = {
  name: "",
  assigned_to: null,
  priority: null,
  status: null,
  notes: null
};
const validations = (values) => {
  const errors = {};
  const { name } = values;
  if (!name || name.replace(/\s/g, "").length === 0) errors.name = "Name is required";
  return errors;
};
function InvestigationForm({ initialValues = INIT_INVESTIGATION, onClose = void 0, onCreate = void 0 }) {
  const sendTelemetry = useSendTelemetry("investigation");
  const { createInvestigation, creatingInvestigation } = useNewInvestigation();
  const onCancel = () => {
    onClose == null ? void 0 : onClose();
  };
  const onSubmit = async (values) => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.SECURITY_APP.INVESTIGATION_UPDATED, {
      app_pathname: "security"
    });
    const payload = {
      ...values,
      assigned_to: values.assigned_to || null,
      priority: values.priority || null,
      status: values.status || null,
      notes: values.notes || null
    };
    const newInvestigation = await createInvestigation({ payload });
    onCreate == null ? void 0 : onCreate(newInvestigation);
    onClose == null ? void 0 : onClose();
  };
  return /* @__PURE__ */ React.createElement(Formik, { initialValues, onSubmit, validate: validations }, /* @__PURE__ */ React.createElement(Modal, { show: true, onHide: onCancel }, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement(Modal.Title, null, "New Investigation")), /* @__PURE__ */ React.createElement(Modal.Body, null, /* @__PURE__ */ React.createElement(FormFields, null)), /* @__PURE__ */ React.createElement(Modal.Footer, null, /* @__PURE__ */ React.createElement(FormButtons, { onCancel, creating: creatingInvestigation }))));
}
export default InvestigationForm;
